import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';
import { last7days } from 'views/Dashboard/ImplementData/utils';
import { Dayjs } from 'lib/dayjs';

export interface FilterCtxType {
  dateRange: [Dayjs, Dayjs];
  // perfRule: 0 | 1;
  assistantIds?: string[];
  conversationType: 1 | 2;
  convertRule: Dashboard.AssistantPerfParams['convertRule'];
  department?: Dashboard.Department;
  departments?: Dashboard.Department[];
}

interface Props {
  children: React.ReactNode;
  initialValue?: Partial<FilterCtxType>;
}

const defaultValue: FilterCtxType = { dateRange: last7days(), conversationType: 1, convertRule: 1 };
const FilterCtx = createContext<{
  value: FilterCtxType;
  onChange: Dispatch<SetStateAction<FilterCtxType>>;
}>({
  value: defaultValue,
  onChange: () => {},
});
export const useFilterCtx = () => useContext(FilterCtx);

export const FilterProvider = (props: Props) => {
  const { children, initialValue = {} } = props;
  const [filter, setFilter] = useState({
    ...defaultValue,
    ...initialValue,
  });
  const val = useMemo(() => {
    return {
      value: filter,
      onChange: setFilter,
    };
  }, [filter]);
  return <FilterCtx.Provider value={val}>{children}</FilterCtx.Provider>;
};
